// extracted by mini-css-extract-plugin
export default {"deleteChips":"deleteIconChips_deleteChips__STU7b","chip":"deleteIconChips_chip__JmxUp"};